export default __webpack_public_path__ + "static/media/app-store.a4f672cd.svg";